var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersTraits({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H52C56.4183 0 60 3.58172 60 8V52C60 56.4183 56.4183 60 52 60H8C3.58172 60 0 56.4183 0 52V8Z",
    fill: "#FF6E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 29.125C23.7124 29.125 21.25 26.6626 21.25 23.625C21.25 20.5874 23.7124 18.125 26.75 18.125C29.7876 18.125 32.25 20.5874 32.25 23.625C32.25 26.6626 29.7876 29.125 26.75 29.125Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 37.2852C17.125 36.1022 17.8687 35.0468 18.9827 34.6491C24.0056 32.8551 29.4945 32.8551 34.5172 34.6491C35.6313 35.0468 36.375 36.1022 36.375 37.2852V39.094C36.375 40.7267 34.9289 41.981 33.3126 41.75L32.0003 41.5626C28.5177 41.0651 24.9822 41.0651 21.4997 41.5626L20.1874 41.75C18.5711 41.981 17.125 40.7267 17.125 39.094V37.2852Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 29.125H41.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.125 26.375V31.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTraits);
export default __webpack_public_path__ + "static/media/users_traits.cd863bc8c837cd7b803d666cfd7d620d.svg";
export { ForwardRef as ReactComponent };